import { ReactNode } from 'react';

import Header from '@/components/Header';
import { useAuth } from '@/hooks/useAuth';

interface LayoutProps {
  children: ReactNode;
  header?: boolean;
}

function Layout({ children, header = true }: LayoutProps) {
  const { logout } = useAuth();

  return (
    <div className="min-h-screen w-full bg-[#e3e0de] overflow-y-scroll">
      <div className="min-h-screen w-full lg:w-1/2 mx-auto bg-[#f8f6f4] shadow-lg flex flex-col">
        {header && (
          <Header onLogout={logout} />
        )}
        <main className="flex-1 w-full">
          {children}
        </main>
      </div>
    </div>
  );
}

export default Layout;
